import { useMemo } from "react";

const weekDays = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];

// Helpers locaux
const toYmd = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const ServiceCalendar = ({
  currentMonth,
  slotsByDate,
  selectedDate,
  onSelectDate,
}) => {
  // Grille 6x7 (42 jours)
  const calendarDays = useMemo(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();

    const firstDay = new Date(year, month, 1);
    const startDate = new Date(firstDay);
    // JS: 0 = Dimanche, ... 6 = Samedi
    startDate.setDate(startDate.getDate() - firstDay.getDay());

    const days = [];
    const current = new Date(startDate);

    for (let i = 0; i < 42; i++) {
      const dateStr = toYmd(current);
      const hasSlots = !!slotsByDate[dateStr]?.length;
      const isCurrentMonth = current.getMonth() === month;
      const isToday = dateStr === toYmd(new Date());
      const isSelected = selectedDate === dateStr;

      days.push({
        date: new Date(current),
        dateStr,
        day: current.getDate(),
        hasSlots,
        isCurrentMonth,
        isToday,
        isSelected,
      });

      current.setDate(current.getDate() + 1);
    }
    return days;
  }, [currentMonth, slotsByDate, selectedDate]);

  return (
    <div className="p-2">
      {/* Jours de la semaine */}
      <div className="grid grid-cols-7 gap-1 mb-1">
        {weekDays.map((day) => (
          <div
            key={day}
            className="text-center text-[10px] font-semibold text-gray-500 py-1"
          >
            {day}
          </div>
        ))}
      </div>

      {/* Jours */}
      <div className="grid grid-cols-7 gap-1">
        {calendarDays.map((day, idx) => {
          const isClickable = day.hasSlots && day.isCurrentMonth;
          return (
            <button
              key={idx}
              onClick={() => onSelectDate(day)}
              disabled={!isClickable}
              className={`
                h-8 w-8 mx-auto rounded-full text-[11px] font-medium transition-all relative
                ${!day.isCurrentMonth ? "text-gray-300" : ""}
                ${day.isToday && !day.isSelected ? "ring-1 ring-primary" : ""}
                ${
                  day.isSelected
                    ? "bg-[#FFD76A] text-primary border border-primary shadow-sm scale-105"
                    : ""
                }
                ${
                  day.hasSlots && day.isCurrentMonth && !day.isSelected
                    ? "bg-primary text-white border border-primary hover:bg-primary/80 cursor-pointer"
                    : ""
                }
                ${
                  !day.hasSlots && day.isCurrentMonth && !day.isSelected
                    ? "text-gray-400 cursor-not-allowed"
                    : ""
                }
              `}
            >
              {day.day}
              {day.hasSlots && day.isCurrentMonth && (
                <span
                  className={`absolute bottom-0.5 left-1/2 -translate-x-1/2 text-[6px] leading-none ${
                    day.isSelected ? "text-primary" : "text-white"
                  }`}
                >
                  •
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ServiceCalendar;
